import React from 'react'
// import Img from 'gatsby-image'
import SlideInTop from '../utility/slideInTopAnimation'
// import SlideInRight from '../utility/slideInRightAnimation'
import PropTypes from 'prop-types'

const ProductsDisplay = props => (
  <div className="bg-gray-50 md:py-24 px-2 md:px-0">
      {props.intro && (
          <SlideInTop>
            <h4 className="text-2xl font-semibold text-center my-4">
              {props.intro}
            </h4>
          </SlideInTop>
      )}
      <div className="section grid grid-cols-1 gap-y-8">
          {props.product1}
          {props.product2 && (
            <div>{props.product2}</div>
          )}
          {props.product3 && (
            <div>{props.product3}</div>
          )}
      </div>
  </div>
)

export default ProductsDisplay
